<template>
  <b-modal
    id="addCompany"
    size="xl"
    :title="$translate('New Company')"
    hide-footer
    centered
    content-class="rounded-8"
    @close="clear"
    @show="show"
    @hide="hide"
  >
    <div class="row">
      <div v-for="i in upsert" :key="i.value" :class="` col-lg-6 col-sm-12 col-xs-12 ${i.type === 'color' ? 'center-color' : ''}`">
        <Input v-if="!i.type || i.type === 'input'" v-model="data[i.value]" :form-group-id="i.name" :placeholder="i.name" :required="i.required" />
        <Select
          v-if="i.type === 'select'"
          v-model="data[i.value]"
          :options="i.data"
          :form-group-id="i.name"
          :placeholder="i.name"
          :required="i.required"
        />
        <div class="add-company-btn" v-if="i.isAddButton" v-b-modal.addContactDetails>{{ 'Add Contact' | i18n }}</div>
      </div>
      <AddContactDetails :afterSave="initData" />
      <div class="row w-100 mx-0">
        <div class="col-12 col-lg-12 col-sm-12 col-xs-12 button-wrapper">
          <b-button variant="outline-secondary" size="lg" class="btn-delete-device px-5" @click="close">
            {{ 'Close' | i18n }}
          </b-button>
          <b-button
            variant="outline-primary"
            size="lg"
            class="btn-delete-device ml-4 px-5"
            :disabled="submitDissabled"
            @click="onSubmit"
          >
            {{ 'Save' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../../../../common/input';
import Select from '../../../../common/select';
import AddContactDetails from './add-contact-details';
import Notification from '../../../../common/notification';

import { NotificationMixin } from '../../../../../../mixins';
import api from '../../../../../api';

export default {
  title: 'New Supplier',
  components: { Input, Select, AddContactDetails },
  mixins: [NotificationMixin],
  props: {
    afterSave: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      upsert: [
        { value: 'company', name: 'Company', required: true },
        { value: 'companyHeadquarters', name: 'Company headquarters' },
        { value: 'branch', name: 'Branch' },
        { value: 'contactPerson', name: 'Contact Person' },
        { value: 'businessHours', name: 'Business hours' },
        { value: 'contactDetails', name: 'Contact details', type: 'select', data: [], isAddButton: true }
      ],
      data: {},
      preventCloseLocal: true,
      initDataForCheck: {}
    };
  },
  computed: {
    submitDissabled: function() {
      let isDissabled = false;
      this.upsert.forEach(u => {
        if (u.required && !this.data[u.value]) {
          isDissabled = true;
        }
      });
      return isDissabled;
    }
  },
  methods: {
    async show() {
      this.clear();
      this.initData();
      this.initDataForCheck = Object.assign({}, this.data);
    },
    async initData() {
      const contactDetails = await api.contactDetails.get();
      this.upsert.forEach(i => {
        if (i.value === 'contactDetails') {
          i.data = contactDetails.map(c => ({ value: c.id, text: `${c.telephoneNumber} (${c.email})` }));
        }
      });
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'addCompany');
    },
    clear() {
      this.data = {};
    },
    hide(e) {
      let isModified = true;

      const lengthCurrent = Object.keys(this.data).length;
      const lengthInit = Object.keys(this.initDataForCheck).length;
      if (lengthCurrent == lengthInit) {
        isModified = false;
      }

      if (this.preventCloseLocal && isModified) {
        let message = confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
        if (!message) {
          return e.preventDefault();
        }
        this.clear();
      }
    },
    async onSubmit() {
      try {
        this.preventCloseLocal = false;
        const company = await api.suppliers.create(this.data);
        this.$root.$emit('bv::hide::modal', 'addCompany');
        await this.afterSave(company);
        Notification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        Notification({ type: 'error', message: err.message });
        this.preventCloseLocal = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep  #add-customer .modal-dialog {
  max-width: 700px !important;
}

::v-deep  .button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.center-color {
  justify-content: center;
  align-items: center;
  display: flex;
}

::v-deep  .add-company-btn {
  color: #2260ff;
  position: absolute;
  margin-top: -25px;
  cursor: pointer;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
